module.exports = __webpack_public_path__ + "static/media/YF59_0.4525e313.jpg";